'use client'
import { Image } from '@/components'
import appConfig from '@/config/global-config'
import { URL_ICON, URL_IMG } from '@/constants/ui'
import { SettingsProvider } from '@/contexts/settings/provider'
import { ThemeProvider } from '@/theme'
import { Box, Button, Stack, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { useCallback, useEffect, useState } from 'react'

interface ErrorPageProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function Error({ error, reset }: ErrorPageProps) {
  // const [email, setEmail] = useState(DEFAULT_REPORT_EMAIL)
  const [isInit, setisInit] = useState(false)
  const [reloadCount, setReloadCount] = useState(0)
  const [showErrorPage, setShowErrorPage] = useState(false)

  /**
   * Gửi thông tin referral đến Telegram
   */
  const sendReferralToTelegram = useCallback(() => {
    const referralData = getWebsiteReferral()
    if (referralData?.currentURL?.includes('localhost')) {
      return
    }
    let bodyContent = `🛑 <b>Lỗi giao diện #error_fe</b>\n<code>${error?.toString()}</code>`

    bodyContent += `\n\n---\n\n 🌐 <b>Referral:</b> \n <code>${JSON.stringify(referralData, null, 2)}</code>`

    postMessageToTelegram(bodyContent)
  }, [error])

  useEffect(() => {
    if (!isInit) {
      setisInit(true)

      // Lấy số lần reload từ sessionStorage
      const currentReloadCount = parseInt(sessionStorage.getItem('error_reload_count') || '0', 10)
      setReloadCount(currentReloadCount)

      // Gửi lỗi tới Telegram ngay lập tức (trước khi reload)
      if (currentReloadCount === 0) {
        sendReferralToTelegram()
      }

      if (currentReloadCount < 1) {
        // Tăng số lần reload và lưu vào sessionStorage
        sessionStorage.setItem('error_reload_count', String(currentReloadCount + 1))

        // Reload trang sau 2 giây
        setTimeout(() => {
          if (window.location.href.includes('localhost')) return
          window.location.reload()
        }, 1500)
      } else {
        // Đã reload đủ 2 lần, hiển thị trang lỗi
        setShowErrorPage(true)
        // Xóa bộ đếm reload
        sessionStorage.removeItem('error_reload_count')
      }
    }
  }, [isInit, sendReferralToTelegram])
  return (
    <html suppressHydrationWarning>
      <body suppressHydrationWarning>
        <SettingsProvider defaultSettings={appConfig}>
          <ThemeProvider>
            <Box
              sx={{
                minHeight: '100vh',
                height: {
                  xs: 'auto',
                  lg: '100vh',
                },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  bgcolor: 'rgba(0, 0, 0, 0.8)',
                  zIndex: -1,
                }}
              />
              <Box
                sx={{
                  p: 2,
                  overflow: 'hidden',
                  boxShadow: '1px 1px 10px rgba(0,0,0,0.1)',
                  width: '100%',
                  height: '100%',
                  minHeight: '100%',
                  position: 'relative',
                }}
              >
                <Image
                  src={URL_IMG + 'error-bg.jpg'}
                  alt=""
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    zIndex: -1,
                  }}
                />
                <Stack
                  spacing={4}
                  component={'main'}
                  minHeight={'100vh'}
                  alignItems={'center'}
                  justifyContent={'center'}
                >
                  <Image
                    src={URL_IMG + 'logo.png'}
                    sx={{
                      width: '10em',
                    }}
                    alt=""
                  />
                  <Typography
                    fontWeight={800}
                    sx={{
                      fontSize: {
                        xs: '25vw',
                        lg: '200px',
                      },
                    }}
                    lineHeight={0.8}
                    variant="h2"
                    align="center"
                    mt={4}
                  >
                    500
                  </Typography>
                  <Typography
                    align="center"
                    fontSize={{
                      xs: '1em',
                      lg: '1.2em',
                    }}
                  >
                    Bạn đã tìm thấy một lỗi vô cũng kì lạ. <br />
                    Hãy ghi nhớ các thao tác vừa rồi của bạn và liên hệ ngay đến email: <br />
                    <Box
                      component="span"
                      sx={{
                        fontWeight: 600,
                        fontSize: '1.2em',
                      }}
                    >
                      support@hydrashop.vn
                    </Box>{' '}
                    <br />
                    Để chúng tôi sửa lỗi trên.
                  </Typography>
                  <Typography
                    variant="h6"
                    align="center"
                    fontSize={{
                      xs: '1.2em',
                      lg: '2.5em',
                    }}
                    fontWeight={600}
                  >
                    ĐỘI NGŨ{' '}
                    <Image
                      src={URL_ICON + 'logo-1.png'}
                      sx={{
                        width: '3.5em',
                      }}
                      alt=""
                    />{' '}
                    CHÂN THÀNH CẢM ƠN SỰ ĐÓNG GÓP CỦA BẠN.
                  </Typography>
                  <Button
                    href="/"
                    variant="contained"
                    sx={{
                      p: '12px 24px',
                      borderRadius: '8px',
                      borderColor: '#BBBBBA',
                      maxWidth: '406px',
                      width: '100%',
                    }}
                  >
                    Quay về trang chủ
                  </Button>
                </Stack>
              </Box>
            </Box>
          </ThemeProvider>
        </SettingsProvider>
      </body>
    </html>
  )
}

export const TELE_BOT_URL =
  'https://super-breeze-b970.vutandat29092000.workers.dev/bot7684766685:AAFaHgglGyNQuuA_SvROP1G_SRhLiYb02MU/sendMessage'
export const GET_EMAIL_REPORT_URL = 'https://api.mona.academy/pub/email-support.json'

export function postMessageToTelegram(text: string) {
  //Chỉ gửi tin nhắn 1 lần trong ngày
  const isPostMessage = localStorage.getItem('isPostMessage') == dayjs().format('YYYY-MM-DD')
  if (isPostMessage) {
    return
  }
  try {
    const botHeaders = new Headers()
    botHeaders.append('Content-Type', 'application/json')

    const raw = JSON.stringify({
      // chat_id: '-4719988294',
      chat_id: '-4937587778',
      //   message_thread_id: 12,
      text: text || 'No message',
      parse_mode: 'html',
    })

    fetch(TELE_BOT_URL, {
      method: 'POST',
      headers: botHeaders,
      body: raw,
    })

    localStorage.setItem('isPostMessage', dayjs().format('YYYY-MM-DD'))
  } catch (error) {}
}
export const getWebsiteReferral = () => {
  return {
    currentURL: window.location.href,
    hostname: window.location.hostname,
    protocol: window.location.protocol,
    pathname: window.location.pathname,
    port: window.location.port,
    referrer: document.referrer,
    historyLength: window.history.length,
    queryString: window.location.search,
    params: Object.fromEntries(new URLSearchParams(window.location.search)),
    userAgent: navigator.userAgent,
    isMobile: /Mobi|Android/i.test(navigator.userAgent),
    isTablet: /Tablet|iPad/i.test(navigator.userAgent),
    isDesktop: !/Mobi|Android|Tablet|iPad/i.test(navigator.userAgent),
    loadTime: new Date().toISOString(),
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    //@ts-ignore
    connectionType: navigator.connection?.effectiveType,
    //@ts-ignore
    downlink: navigator.connection?.downlink,
    //@ts-ignore
    rtt: navigator.connection?.rtt,
    //@ts-ignore
  }
}
